import Button from 'components/button';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styles from '../estimate/components/forms/formMarketPrice/styles.module.scss';
import useEstimateById from 'api/hooks/use-estimate-by-id';
import { MarketTypes } from 'api/types';

const useGetMarketPrice = (
  handleModalSupport: (value: boolean) => void,
  marketType: MarketTypes,
  apartmentId: number,
) => {
  const [error, setError] = useState<string>('');
  const [isShowError, setIsShowError] = useState(false);

  const {
    data,
    isMutating,
    trigger,
    error: errorEstimateById,
  } = useEstimateById(marketType, apartmentId);

  const onSubmit = async () => {
    trigger();
  };

  useEffect(() => {
    if (errorEstimateById) {
      setError(errorEstimateById);
    }
  }, [errorEstimateById, isMutating]);

  useEffect(() => {
    if (!isMutating) {
      setIsShowError(true);
    } else {
      setIsShowError(false);
    }
  }, [isMutating]);

  useEffect(() => {
    if (error && !isMutating && isShowError) {
      toast(
        <div className={styles.toast}>
          {error
            ?.split('.')
            ?.map((text) => text && <p className={styles.toast__text}>{text + '.'}</p>)}
          <div className={styles.toast__button}>
            <Button
              label='Оставить заявку'
              onClick={() => {
                handleModalSupport(true);
                toast.dismiss();
              }}
            />
          </div>
        </div>,
      );
    }
  }, [error, isMutating, isShowError]);

  return {
    onSubmit,
    data,
    isMutating,
  };
};

export default useGetMarketPrice;
